import { AgentSipConfig } from "~/types/AgentSipConfig";
import { getRequest, postRequest } from "~/apis/requests/useApiCall";

type ConnectionStatus =
  | "disconnected"
  | "connected"
  | "connected_elsewhere"
  | "failed";

export const useAgentSipConfigStore = definePiniaStore("agentSipConfigStore", {
  state: () => ({
    callerId: "",
    callerQueue: "",
    callStatus: "Idle",
    _connectionStatus: "disconnected" as ConnectionStatus,
    _connectionMessage: "You are not connected",
  }),
  persist: true,
  actions: {
    async isOtherAsteriskSessionsConnected(): Promise<boolean> {
      const { response } = await getRequest<boolean>(
        "cc/agent/isAsteriskConnected"
      );
      return response.data;
    },

    async requestOtherAsteriskSessionsDisconnect(
      randomId: string
    ): Promise<boolean> {
      const { error } = await postRequest<any>(
        "cc/agent/requestAsteriskSessionsDisconnect",
        { requesterRandomId: randomId }
      );
      return error === null;
    },

    // mutations

    setConnectionOk() {
      this._connectionStatus = "connected";
      this._connectionMessage =
        "Your connection is OK. Ready to make and receive calls";
    },
    setConnectedElsewhere() {
      this._connectionStatus = "connected_elsewhere";
      this._connectionMessage =
        "You are connected in another session. Click here to disconnect other session and connect this session";
    },
    setConnectionFailed() {
      this._connectionStatus = "failed";
      this._connectionMessage =
        "Connection failed, please check your network connection and try again by refreshing page";
    },
    setDisconnected() {
      this._connectionStatus = "disconnected";
      this._connectionMessage = "You have been disconnected";
    },
    setDisconnectedByOther() {
      this._connectionStatus = "connected_elsewhere";
      this._connectionMessage =
        "You have been disconnected by other session. Click here to disconnect other session and connect this session";
    },
  },
  getters: {
    connectionStatus: (state) => state._connectionStatus,
    connectionMessage: (state) => state._connectionMessage,
  },
});
